import instance from './instance';

// TODO: for now the comment system is only supported for goals. Once we make it more generic
// we should update this POST endpoint
export const createComment = data => instance.post(`/goals/${data.goal_id}/comments`, data);

export const deleteComment = slug => instance.delete(`/comments/${slug}`);

export const updateComment = data => instance.put(`/comments/${data.slug}`, data);
